import { CSSResultGroup, TemplateResult, html } from 'lit';
import { LightDomStyles, OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-tag.css.lit';
import '../outline-icon-baseline/outline-icon-baseline';

/**
 * The OutlineTag component
 * @element outline-tag
 */
@customElement('outline-tag')
export class OutlineTag extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  /**
   * Whether the link is facet.
   */
  @property({ type: Boolean, attribute: 'is-facet', reflect: true })
  isFacet = false;

  firstUpdated(): void {
    if (this.isFacet) {
      this.addIcon();
    }
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }

  addIcon() {
    const element = this.querySelector(':scope a');
    const iconName = 'eu-x';
    const iconSize = 'var(--tag-icon-size)';

    const icon = document.createElement('outline-icon-baseline');
    icon.setAttribute('size', iconSize);
    icon.setAttribute('name', iconName);
    icon.setAttribute('svg-fill', 'currentColor');
    icon.classList.add('tag-icon-close');
    element?.appendChild(icon);
  }
}
